<template>
  <div class="height-100-p">
    <el-form :model="editForm" :rules="editFormRules" ref="editForm">
    <el-table
      :data="door.list"
      v-loading="door.loadingSearch"
      id="door-data-list"
      size="mini"
      tooltip-effect="dark"
      class="dark-blue-table"
      :empty-text="$t('common.notAbleToFindRecords')"
      stripe
    >
      <el-table-column
        prop="number"
        :label="$t('door.number')"
        :min-width="5"
        align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.edit">
            <el-form-item prop="number">
                  <el-input
                  v-model="editForm.number"
                  v-numeric-validation
                  maxlength="25"
                  class="inline-input"
                  id="row-form-number"
                  ref="row-form-number"
                  ></el-input>
              </el-form-item>
          </template>
          <template v-else>
            <b class="door-number">{{ scope.row.number }}</b>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        prop="receiving"
        :label="$t('door.receiving')"
        :min-width="5"
        align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.edit">
            <el-form-item prop="receiving">
                <el-select v-model="editForm.receiving" class="inline-input" size="mini">
                  <el-option :label="yes.label" :value="yes.value"></el-option>
                  <el-option :label="no.label" :value="no.value"></el-option>
                </el-select>
            </el-form-item>
          </template>
          <template v-else>
            <i v-if="scope.row.receiving" class="el-icon-success green-success"></i>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        prop="outbound"
        :label="$t('door.outbound')"
        :min-width="5"
        align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.edit">
            <el-form-item prop="outbound">
                <el-select v-model="editForm.outbound" class="inline-input" size="mini">
                  <el-option :label="yes.label" :value="yes.value"></el-option>
                  <el-option :label="no.label" :value="no.value"></el-option>
                </el-select>
            </el-form-item>
          </template>
          <template v-else>
            <i v-if="scope.row.outbound" class="el-icon-success green-success"></i>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        prop="active"
        :label="$t('door.active')"
        :min-width="5"
        align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.active" class="el-icon-success green-success"></i>
        </template>
      </el-table-column>
      <el-table-column
        prop="loadShuttle"
        :label="$t('door.loadShuttle')"
        :min-width="5"
        align="center">
        <template slot-scope="scope">
          {{ scope.row.loadNumber }}
        </template>
      </el-table-column>
      <el-table-column
        prop="trailer"
        :label="$t('door.trailer')"
        :min-width="5"
        align="center">
        <template slot-scope="scope">
          {{ scope.row.trailer }}
        </template>
      </el-table-column>
      <el-table-column prop="options" :label="$t('door.options')" :min-width="4" align="center">
        <template slot-scope="scope">
          <el-tooltip v-if="showEditButton(scope.row)" class="item" effect="dark" :enterable="false" :content="$t('door.edit')" placement="top-start">
            <i class="el-icon-edit icon-action" @click="handleEdit(scope.row)"></i>
          </el-tooltip>
          <template v-else-if="scope.row.edit">
            <el-button icon="el-icon-success" circle size="mini" @click="handleUpdate()"></el-button>
            <el-button icon="el-icon-circle-close" circle size="mini" @click="cancelEdit(scope.row)"></el-button>
          </template>
          <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('door.release')" placement="top-start">
            <i class="el-icon-unlock" @click="handleRelease(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    </el-form>
    <div class="pagination-footer" v-show="door.total > 0">
      <span class="el-pagination__total">
        <span class="el-pagination__title">{{ $t('door.totalDoors') }}</span>
        {{ door.total }}
      </span>
      <el-pagination
        @size-change="handleSearchChangeLimit"
        :page-sizes="sizes"
        :page-size="door.actualFilters.rows"
        :current-page.sync="door.actualFilters.page"
        @current-change="handleSearchChangePage"
        :total="door.total"
        layout="sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>

import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'SearchSummary',
  computed: {
    ...mapGetters(['door'])
  },
  data() {
    return {
      editForm: {
        id: null,
        number: null,
        receiving: null,
        outbound: null
      },
      editFormRules: {
        number: [
          { required: true, message: this.$t('door.error.numberRequired'), trigger: 'submit' }
        ]
      },
      yes: constants.STATUS_BOOLEAN.yes,
      no: constants.STATUS_BOOLEAN.no,
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES
    };
  },
  methods: {
    handleSearchChangePage(val) {
      this.$store.dispatch('door/search', { page: val });
    },
    handleSearchChangeLimit(val) {
      this.$store.dispatch('door/search', { rows: val, page: constants.TABLES.DEFAULT_PAGE });
    },
    handleEdit(row) {
      this.$store.dispatch('door/setEditingRow', true);
      row.edit = true;
      this.editForm.id = row.id;
      this.editForm.number = row.number;
      this.editForm.receiving = row.receiving;
      this.editForm.outbound = row.outbound;
    },
    clearEdit() {
      this.$store.dispatch('door/setEditingRow', false);
      this.$refs.editForm.resetFields();
    },
    cancelEdit(row) {
      row.edit = false;
      this.clearEdit();
    },
    handleRelease(row) {
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.$store.dispatch('door/release', { doorId: row.id })
        .then((response) => {
          this.$message.success(response.message);
          this.$store.dispatch('door/search', {});
        })
        .catch(() => {
          this.$message.error(this.$t('door.error.releaseDoor').replace('[doorNumber]', row.number));
        }).finally(() => {
          loading.close();
        });
    },
    handleUpdate() {
      this.$refs.editForm.validate((valid, validationsErrors) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.$store
            .dispatch('door/update', {
              doorId: this.editForm.id,
              doorToUpdate: this.editForm
            })
            .then((response) => {
              loading.close();
              this.$message.success(response.message);
              this.clearEdit();
              this.$store.dispatch('door/search', {});
            })
            .catch(() => {
              loading.close();
            });
        } else {
          let errorMessage = '';
          Object.keys(validationsErrors).forEach((key) => {
            validationsErrors[key].forEach((validation) => {
              errorMessage += `${validation.message}. `;
            });
          });
          this.$message.warning(errorMessage);
        }
      });
    },
    showEditButton() {
      return this.$can(this.permissions.WAREHOUSE.EDIT_DOORS) && !this.door.isEditingRow;
    },
  }
};
</script>
